import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'


import AgentsList from './AgentsList'
import AgentForm from '../agentForm'
import agents from 'selectors/agents'
import { properties } from 'selectors/entities'

import mobileActions from 'actions/mobile'
import actionBarActions from 'actions/actionbar'
import AgentsFiltersActions from 'actions/agents'
import rightStackActions from 'actions/rightStackActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import yelpActions from 'actions/yelp'
import dataActions from 'actions/dataActions'
import Error from 'components/Error'
import loginActions from 'actions/login'

let select = (state) => ({
    ...state
  , agents: agents(state)
  , properties: properties(state)
  })
export class Agents extends Component {
	render() {
		try{
			return(

						<AgentsList
							agents={this.props.agents}
							openPanel={this.props.OPEN_PANEL}
							filtersIsOpened={this.props.actionBarReducers.rightNav}
							rightStackOpened={!!this.props.routeParams.id}
							navPanelIsOpened={this.props.actionBarReducers.leftNav}
							lastInteracted={(this.props.routeParams.id)?
								this.props.routeParams.id
								: ''
							}
							count={R.values(this.props.agents).length}
							refTask={(this.props.routing.locationBeforeTransitions.state && this.props.routing.locationBeforeTransitions.state.refTask)?this.props.routing.locationBeforeTransitions.state.refTask: undefined}
							docUpd = {this.props.DOC_UPDATE}
							history = {this.props.history}
							property={this.props.agentsFilters.property}
							properties={this.props.properties}
							docUpd={this.props.DOC_UPDATE}
							filtersUPD={this.props.AGENTS_FILTER_UPDATED}
							agentsFilters={this.props.agentsFilters}
							data={this.props.data}
							switchYelp={this.props.SWITCH_YELP}
							yelpIsOn={this.props.yelp.isOn}
							updCategoryYelp={this.props.CHANGE_CATEGORY}
							yelpCategory={this.props.yelp.category}
							filters={this.props.actionBarReducers.rightNav}
							toggleFilt={this.props.TOOGLE_FILTERS_PANEL}
						/>

			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([actionBarActions, AgentsFiltersActions, mobileActions, loginActions, yelpActions, rightStackActions, attachmentOverlayActions, dataActions]))(Agents)



// WEBPACK FOOTER //
// ./src/routes/manager/agents/index.js